import { useState } from 'react';

export function useImageViewerState(initialState: boolean) {
  const [visible, setState] = useState(initialState);
  const open = () => {
    setState(true);
  };
  const close = () => {
    setState(false);
  };
  const toggle = () => {
    setState(!visible);
  };

  return { visible, open, close, toggle };
}
